import React, { useState, useEffect } from "react";
import HeaderBar from "../components/HeaderBar";
import Sidebar from "../components/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileContract,
  faHourglassClock,
  faTally,
  faUsers,
} from "@fortawesome/pro-regular-svg-icons";
import {
  getAgreementsForUser,
  getContactPersonForAgreement,
} from "../api/Agreement";
import { useAuth } from "../providers/AuthContext";
import LoadingAgreements from "../components/LoadingAgreements";
import ContactPerson from "../components/ContactPerson";

function OverviewPage() {
  const { getAccessToken, getUserRole, user, isRole } = useAuth();
  const [agreements, setAgreements] = useState([]);
  const [loading, setLoading] = useState(true);
  const userRole = getUserRole();
  const [contactPerson, setContactPerson] = useState(null);

  useEffect(() => {
    const fetchContactPerson = async () => {
      try {
        const accessToken = await getAccessToken();
        if (agreements.length > 0) {
          const agreementId = agreements[0].agreementPublicId;
          const data = await getContactPersonForAgreement(
            agreementId,
            accessToken
          );
          setContactPerson(data);
        }
      } catch (error) {
        console.error("Failed to fetch contact person:", error);
      }
    };

      fetchContactPerson();
  }, [agreements, getAccessToken, loading]);

  useEffect(() => {
    const fetchAgreements = async () => {
      try {
        const accessToken = await getAccessToken();
        const data = await getAgreementsForUser(accessToken);

        setAgreements(data);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch agreements:", error);
        setLoading(false);
      }
    };

    fetchAgreements();
  }, [getAccessToken, user]);

  const image = "/assets/images/person.png";

  const StatCard = ({ icon, title, value, bgColor }) => (
    <div className="flex flex-col items-center border rounded-lg bg-primary-600 flex-grow min-w-[12rem] h-[9.5rem] p-4">
      <div className="flex flex-row items-center w-full">
        <div
          className={`flex items-center justify-center h-[3.125rem] w-[3.125rem] rounded-full ${bgColor} mr-4`}
        >
          <FontAwesomeIcon icon={icon} className="text-white" />
        </div>
        <h1 className="text-white text-sm">{title}</h1>
      </div>
      <div className="flex items-center justify-center w-full -mt-4">
        <h1 className="text-white text-[40px] font-bold">{value}</h1>
      </div>
    </div>
  );

  const mockData = [
    { icon: faTally, title: "licenses", value: 20, bgColor: "bg-primary-500" },
    { icon: faUsers, title: "Users", value: 16, bgColor: "bg-primary-500" },
    {
      icon: faHourglassClock,
      title: "Expiring",
      value: 3,
      bgColor: "bg-error-300",
    },
  ];

  const renderAgreements = () =>
    agreements.map((agreement) => (
      <div
        key={agreement.agreementPublicId}
        className="bg-primary-100 w-full md:w-1/2 min-w-[233px] rounded-lg shadow-md px-[2rem] py-[1rem] min-h-[10rem]"
      >
        <h3 className="pb-[1rem]">Agreement</h3>
        <div className="flex flex-row">
          <div className="flex items-center aspect-square justify-center h-[4.7rem] w-[4.7rem] rounded-full bg-primary-500">
            <FontAwesomeIcon
              icon={faFileContract}
              className="text-white w-[28px] h-[37px]"
            />
          </div>
          <div className="flex flex-col pl-[1rem]">
            <p className="text-base">{agreement.name}</p>
            <p className="text-base">{agreement.status}</p>
            <p className="text-sm text-primary-500">View PDF</p>
          </div>
        </div>
      </div>
    ));

  const renderContent = () => (
    <>
      <HeaderBar />
      <div className="flex">
        <Sidebar />
        <div className="page">
          <img
            src="/assets/images/imageBG2.png"
            className="-z-10 object-cover absolute opacity-25 w-full h-full"
            alt="Background"
          />
          <div className="page-content">
            <div className="px-[9.5rem]">
              <div className="flex flex-col items-center">
                <div className="p-4 max-w-[48.125rem]">
                  <h1 className="text-center text-3xl font-bold pb-4">
                    Welcome {user ? user.name : "Guest"}
                  </h1>
                  <p className="text-center py-4">
                    Here you can find licenses and users connected to your
                    account. If you need some assistance, please contact your
                    contacts below or our support at 23232323.
                  </p>
                </div>
                {isRole("admin") && (
                  <div className="flex flex-col md:flex-row w-full gap-4 items-center max-w-[66.875rem] pb-4">
                    {mockData.map((item, index) => (
                      <StatCard
                        key={index}
                        icon={item.icon}
                        title={item.title}
                        value={item.value}
                        bgColor={item.bgColor}
                      />
                    ))}
                  </div>
                )}
                <div className="flex flex-col md:flex-row w-full gap-4 items-center max-w-[66.875rem]">
                  {loading ? <LoadingAgreements /> : renderAgreements()}

                  {loading ? <LoadingAgreements /> : <ContactPerson contactPerson={contactPerson} bgColor="bg-primary-100" />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

    </>
  );

  return renderContent();
}

export default OverviewPage;
